<template>
  <aside class="info_left_board">
    <nav class="navigation">
      <RouterLink activeClass="active" to="/" class="nav__item">
        <img :src="themeImage" alt="Home" loading="lazy">
        {{ $t('menu.home') }}
      </RouterLink>

      <RouterLink v-if="auth.user" activeClass="active" to="/profile" class="nav__item_avatar">
        <Avatar :user="auth.user" />
        {{ $t('menu.profile') }}
      </RouterLink>
    </nav>

    <div class="qr_box">
      <div class="qr">
        <img :src="currentQrImage" alt="QR Code" class="qr_image" loading="lazy" />
      </div>
      <a
        href="https://comixon.onelink.me/etVZ?af_xp=custom&pid=Comixon&af_dp=comixonApp%3A%2F%2F&deep_link_value=open_my_profile">
        {{ $t('download') }}
      </a>
      <p>© 2025 Comixon by Orange Rockets</p>
    </div>
  </aside>
</template>

<script setup>
import { ref, watch } from "vue";
import { useThemeStore } from "../stores/themeStore";
import { useAuthStore } from "../stores/authStore";
import { RouterLink } from "vue-router";
import Avatar from "./Avatar.vue";

const themeStore = useThemeStore();
const currentQrImage = ref("");
const themeImage = ref("");
const auth = useAuthStore();

const updateImage = () => {
  currentQrImage.value = themeStore.isDark
    ? new URL("/qr.png", import.meta.url).href
    : new URL("/qr_light.png", import.meta.url).href;

  themeImage.value = themeStore.isDark
    ? new URL("/home.svg", import.meta.url).href
    : new URL("/home-light.svg", import.meta.url).href;
}

updateImage();
watch(() => themeStore.isDark, updateImage);
</script>

<style>
.info_left_board {
  color: #454545;
  max-width: 150px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 85%;
  position: fixed;
  left: 49px;
}

.info_left_board a {
  color: #7d7d7d;
  text-decoration: none;
  transition: all var(--transition-time) ease;
  font-weight: 400;
}

.info_left_board a:hover {
  color: var(--text-color);
}

.qr_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.qr_box p {
  margin-top: 10px;
}

.qr {
  border-radius: 25px;
  background: var(--qr-bg-color);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--border-color);
  width: 152px;
  height: 152px;
  margin-bottom: 10px;
  transition: background-color var(--transition-time) ease,
    color var(--transition-time) ease;
}

.qr_image {
  width: 120px;
  height: 120px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all var(--transition-time) ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.navigation {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nav__item,
.nav__item_avatar {
  color: rgba(125, 125, 125, 1);
  text-decoration: none;
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
  padding: 8px 24px 8px 8px;
  border-radius: 15px;
  width: fit-content;
  cursor: pointer;
  width: 60%;
}

.nav__item_avatar {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.nav__item_avatar img {
  margin-right: 12px;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}

.nav__item img {
  width: 20px;
  height: 20px;
  padding: 4px;
  margin-right: 12px;
}

.nav__item:hover,
.nav__item_avatar:hover {
  background: var(--hover);
  color: var(--hover);
}

.nav__item.active,
.nav__item_avatar.active {
  background: var(--nav-bg);
  color: var(--text-color);
}

.nav__item.active img {
  opacity: 1;
}

@media (max-width: 1440px) {
  .info_left_board {
    display: none;
  }
}
</style>
